<template>

  <v-layout row justify-center>
    <v-dialog v-model="controlDialogVisible" max-width="800px">

      <v-container grid-list-xl fluid>
        <v-layout row wrap>

          <v-flex :class="classOld">
            <pr-box v-if="log && log.old.length != 0"
            :title="log | auditDetailTitle('before')">
            <div slot="buttons-header">
              <v-btn icon @click.native="closeDialog()">
                <v-icon color="white" >close</v-icon>
              </v-btn>
            </div>
              <div v-for="(value, key) in log.old" :key="key">
                <div v-if="verifyImage(value)" class="text-xs-center">
                  <img class="pictureAudit" :src="value" />
                </div>
                <div v-else>
                  <span> <b>{{ log | attrLog(key) | tAttr}} </b></span> {{ value | auditValue(key)}}
                  <hr/>
                </div>
              </div>
            </pr-box>
          </v-flex>

          <v-flex :class="classNew">
            <pr-box v-if="log && log.new.length != 0"
              :title="log | auditDetailTitle('after')">
              <div slot="buttons-header">
                <v-btn icon @click.native="closeDialog()">
                  <v-icon color="white" >close</v-icon>
                </v-btn>
              </div>
                <div v-for="(value, key) in log.new" :key="key">
                  <div v-if="verifyImage(value)" class="text-xs-center">
                    <img class="pictureAudit" :src="value" />
                  </div>
                  <div v-else>
                    <span> <b>{{ log | attrLog(key) | tAttr}} </b></span> {{ value | auditValue(key)}}
                    <hr/>
                  </div>
                </div>
            </pr-box>
          </v-flex>
        </v-layout>
      </v-container>
    </v-dialog>
  </v-layout>

</template>

<script>
  import i18n from '@/i18n';
  import DialogMixin from '@/components/mixins/DialogMixin';
  import prDatetime from '@/filters/PrDateTimeFilter';
  import { endsWith as _endsWith } from 'lodash';
  import currencyFilter from '@/filters/CurrencyFilter';

  export default {
    mixins: [DialogMixin],
    props: {
      log: {},
    },
    data() {
      return {};
    },
    computed: {
      classOld() {
        return {
          'sm6 offset-sm4 xs12': this.log && this.log.old.length !== 0 && this.log.new.length === 0,
          'sm6 xs12': this.log && this.log.old.length !== 0 && this.log.new.length !== 0,
          'xs12 ': !this.log || this.log.old.length === 0,
        };
      },
      classNew() {
        return {
          'sm6 offset-sm4 xs12': this.log && this.log.new.length !== 0 && this.log.old.length === 0,
          'sm6 xs12': this.log && this.log.new.length !== 0 && this.log.old.length !== 0,
          'xs12 ': !this.log || this.log.new.length === 0,
        };
      },
    },
    methods: {
      verifyImage(value) {
        return typeof value === 'string' && value.startsWith('data:imag');
      },
    },
    filters: {
      auditDetailTitle(auditDetail, status) {
        if (auditDetail && auditDetail.type === 'updated') {
          if (status === 'before') {
            return i18n.t('dialog.audit.updatedBefore');
          }
          return i18n.t('dialog.audit.updatedAfter');
        } else if (auditDetail && auditDetail.type) {
          return i18n.t(`dialog.audit.${auditDetail.type}`);
        }

        return null;
      },
      attrLog(log, key) {
        const modelReplace = log.auditable_type.replace('App\\', '');
        return `${modelReplace.toLowerCase()}.${key}`;
      },
      auditValue(value, key) {
        if (value instanceof Date || _endsWith(key, '_at') || _endsWith(key, '_to')) {
          return prDatetime(value);
        }

        if (typeof value === 'boolean') {
          return i18n.t((value) ? 'global.yes' : 'global.no');
        }

        // eslint-disable-next-line
        if (Number(value) === value && value % 1 !== 0) {
          return currencyFilter(value);
        }

        return value;
      },
    },
  };

</script>

<style>

  .dialog {
    box-shadow: none !important;
  }

  .pictureAudit {
    width:200px;
    height:200px;
  }

</style>



// WEBPACK FOOTER //
// src/features/audit/AuditDetailDialog.vue